import { api, HttpError } from '../api/client.js';
import { navigate } from '../router.js';

export function renderResetPassword(root: HTMLElement): void {
  // The token arrives via ?token=... on the URL the email link points at.
  // We accept it from either window.location.search OR the hash fragment so
  // it works on a fully-hash router.
  const params = new URLSearchParams(window.location.search);
  let token = params.get('token') ?? '';
  if (!token && window.location.hash.includes('?')) {
    const after = window.location.hash.split('?')[1] ?? '';
    token = new URLSearchParams(after).get('token') ?? '';
  }

  if (!token) {
    root.innerHTML = `
      <div class="auth-shell">
        <div class="auth-card">
          <img src="/img/ui/title.webp" alt="Rex Mortis" style="display:block; margin: 0 auto var(--s-3) auto; width: 280px; max-width: 90%; height: auto;" />
          <h1 style="text-align:center;">Missing reset token</h1>
          <p style="text-align:center; font-style:italic; color: var(--c-ink-soft);">
            This reset scroll has no token — perhaps the link was copied incompletely.
          </p>
          <p class="auth-meta">
            <a href="#/forgot-password">Request a new scroll</a>, or <a href="#/login">return to the gate</a>.
          </p>
        </div>
      </div>
    `;
    return;
  }

  root.innerHTML = `
    <div class="auth-shell">
      <div class="auth-card">
        <img src="/img/ui/title.webp" alt="Rex Mortis" style="display:block; margin: 0 auto var(--s-3) auto; width: 280px; max-width: 90%; height: auto;" />
        <h1 style="text-align:center; margin: 0 0 var(--s-1) 0;">Forge a New Word</h1>
        <p class="subtitle" style="text-align:center;">— Choose carefully —</p>

        <div id="msg" class="alert success" hidden></div>
        <div id="err" class="alert danger" hidden></div>

        <form id="resetForm" autocomplete="on">
          <div class="field">
            <label for="newPassword">New password</label>
            <input id="newPassword" name="newPassword" type="password" required minlength="10" maxlength="72" autocomplete="new-password" />
          </div>
          <div class="field">
            <label for="confirm">Confirm new password</label>
            <input id="confirm" name="confirm" type="password" required minlength="10" maxlength="72" autocomplete="new-password" />
          </div>
          <p class="auth-meta" style="margin-bottom: var(--s-3); font-style: italic;">
            Must be at least 10 characters. Completing this will sign out all other sessions.
          </p>
          <button class="btn" type="submit" id="submit">Set new password</button>
        </form>

        <p class="auth-meta">
          <a href="#/login">Return to the gate</a>
        </p>
      </div>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('#resetForm')!;
  const msgBox = root.querySelector<HTMLDivElement>('#msg')!;
  const errBox = root.querySelector<HTMLDivElement>('#err')!;
  const submit = root.querySelector<HTMLButtonElement>('#submit')!;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    msgBox.hidden = true;
    errBox.hidden = true;

    const newPassword = (form.elements.namedItem('newPassword') as HTMLInputElement).value;
    const confirm = (form.elements.namedItem('confirm') as HTMLInputElement).value;

    if (newPassword !== confirm) {
      errBox.textContent = 'The two passwords do not match.';
      errBox.hidden = false;
      return;
    }

    submit.disabled = true;
    submit.textContent = 'Setting password…';

    try {
      await api.resetPassword(token, newPassword);
      msgBox.textContent = 'Password set. Returning thee to the gate…';
      msgBox.hidden = false;
      form.reset();
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      const msg = err instanceof HttpError ? err.message : 'Could not reset password.';
      errBox.textContent = msg;
      errBox.hidden = false;
    } finally {
      submit.disabled = false;
      submit.textContent = 'Set new password';
    }
  });
}
